// TODO Make search work

<template>
  <div id="reportsWrapper">
    <nav v-for="table in visibleTables" :key="table.id" class="panel">
      <p class="panel-heading">{{ table.name }}</p>

      <router-link
        v-for="report in visible(table.reports)"
        :key="report.id"
        :to="{ name: 'show-report', params: { id: report.id } }"
        class="panel-block">

        <span class="panel-icon">
          <i class="fas fa-file-alt" aria-hidden="true"></i>
        </span>

        {{ report.name }}
      </router-link>
    </nav>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      tables: 'tables/tables',
      bundle: 'bundles/bundle',
      reports: 'reports/reports'
    }),
    visibleTables () {
      return this.tables.filter(table => !this.bundle.has_disabled['tables'].includes(table.id))
    }
  },
  methods: {
    visible (reports) {
      return reports.filter(report => !this.bundle.has_disabled['reports'].includes(report.id))
    }
  }
}
</script>
